/**
 * Suppress all console output when VUE_APP_DISABLE_CONSOLE is enabled.
 * GELF logging (via Winston BizTransport) is unaffected.
 * Import this file as early as possible in main.js.
 *
 * We override native console methods instead of only silencing Winston's
 * Console transport because:
 * 1. Raw console.log() calls in the codebase and third-party libraries
 *    bypass Winston entirely, silencing Winston wouldn't suppress them.
 * 2. Winston's Console transport uses console.log() internally, so
 *    overriding the native method silences both Winston console output
 *    and raw console calls in a single place.
 */
if (process.env.VUE_APP_DISABLE_CONSOLE !== 'false') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Exclude these 2 level, as safety net for 3rd party libraries debugging
  // console.warn = () => {};
  // console.error = () => {};
}
